// extracted by mini-css-extract-plugin
export default {"wrapper":"PrimaryWrapper_wrapper__Qfaag"};